import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { AgwRestApiModel } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../../magic/MagicTable';

export type AgwRestApiModelsTableProps = {
  selectable?: boolean;
  loading?: boolean;
  models: AgwRestApiModel[];
  onViewModel?: (model: AgwRestApiModel) => unknown;
  onSelect?: (names: string[]) => void;
};

export const AgwRestApiModelsTable = ({
  models,
  selectable = true,
  loading,
  onViewModel,
  onSelect,
}: AgwRestApiModelsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('APIGateway')}
    entry="Model"
    idAttribute="id"
    rows={models}
    selectable={selectable}
    onSelect={onSelect}
    order={['id', 'name']}
    loading={loading}
    externalFields={{
      id: (row) => (
        <Link onClick={() => onViewModel && onViewModel(row)} underline="hover">
          {row.id}
        </Link>
      ),
    }}
  />
);
